import React from 'react';
import { mockIndustries } from '../mock';
import { ShoppingBag, Cpu, Shirt, Building2, Settings, Store, Car } from 'lucide-react';

const iconMap = {
  ShoppingBag: ShoppingBag,
  Cpu: Cpu,
  Shirt: Shirt,
  Building2: Building2,
  Settings: Settings,
  Store: Store,
  Car: Car
};

const IndustriesSection = () => {
  return (
    <section id="industries" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
            Industries We Support
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Proven expertise across diverse sectors
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-6">
          {mockIndustries.map((industry) => {
            const IconComponent = iconMap[industry.icon];
            const isAutomobile = industry.icon === 'Car';
            const Wrapper = isAutomobile ? 'a' : 'div';
            const wrapperProps = isAutomobile ? { href: '/cars', 'data-testid': 'automobile-link' } : {};
            return (
              <Wrapper
                key={industry.id}
                {...wrapperProps}
                className="bg-white rounded-lg p-6 text-center shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 group cursor-pointer no-underline"
              >
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-900 transition-colors duration-300">
                  <IconComponent className="w-8 h-8 text-blue-900 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-sm font-semibold text-gray-800 group-hover:text-blue-900 transition-colors duration-300">
                  {industry.name}
                </h3>
              </Wrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;